module.exports = __webpack_public_path__ + "static/media/img_6.8b1928f2.png";